import { useArgoContext, FrontEndFeatureSet } from '@awsscm/argo-core';

// Update this flag to true to launch MoveContainer feature in Prod
const moveContainerLaunched = false;

// Update this flag to true to launch Migration feature in Prod
const cmsMigrationFeatureLaunched = true;

// Update this flag to true to launch Zone feature in Prod
const zoneFeatureLaunched = true;

// Update this flag to true to launch IsEmpty flag for containers in Prod
const capacityFilterLaunched = true;

const containerMoveLaunched = false;

export function moveContainerFeatureFlag(): boolean {
  if (moveContainerLaunched) {
    return true;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const context = useArgoContext();
  // Always show in test (e.g. beta)
  return context.frontEndFeatureSet === FrontEndFeatureSet.Test;
}

export function cmsMigrationFeatureFlag(): boolean {
  if (cmsMigrationFeatureLaunched) {
    return true;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const context = useArgoContext();
  // Always show in test (e.g. beta)
  return context.frontEndFeatureSet === FrontEndFeatureSet.Test;
}

export function zoneFeatureFlag(): boolean {
  if (zoneFeatureLaunched) {
    return true;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const context = useArgoContext();
  // Always show in test (e.g. beta)
  return context.frontEndFeatureSet === FrontEndFeatureSet.Test;
}

export function capacityFilterFlag(): boolean {
  if (capacityFilterLaunched) {
    return true;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const context = useArgoContext();
  // Always show in test (e.g. beta)
  return context.frontEndFeatureSet === FrontEndFeatureSet.Test;
}

export function containerMoveFlag(): boolean {
  if (containerMoveLaunched) {
    return true;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const context = useArgoContext();
  // Always show in test (e.g. beta)
  return context.frontEndFeatureSet === FrontEndFeatureSet.Test;
}
